import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeFieldType } from './types';

export interface CreateIncomeFieldTypeParams {
  name: string;
  displayName?: string | null;
  documentTypeId: string;
  inUse?: boolean;
  formula?: string | null;
}

const createIncomeFieldType: MutationFunction<
  IncomeFieldType,
  CreateIncomeFieldTypeParams
> = async (params) => {
  if (isMockServices())
    return await mock({
      ...params,
      id: `ift-${Date.now()}`,
      inUse: params.inUse ?? true,
      isDeleted: false,
    } as IncomeFieldType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: IncomeFieldType;
  }>('/income-field-types', {
    method: 'POST',
    body: {
      name: params.name,
      ...(params.displayName !== undefined && {
        displayName: params.displayName,
      }),
      documentTypeId: params.documentTypeId,
      ...(params.inUse !== undefined && { inUse: params.inUse }),
      ...(params.formula !== undefined && { formula: params.formula }),
    },
  });

  if (response.data) return response.data.data;
  throw new Error('Failed to create income field type');
};

export default createIncomeFieldType;
